export default __webpack_public_path__ + "static/media/Artie Negron Resume.00b08747.pdf";